import { useEffect, useState } from 'react'
import { OrganisationCouncilFieldsEdit, OrganisationFieldsView } from '../../../../../../types/form-types'
import { useGetWellData } from '../../../../../hooks/use-api'
import OrganisationCouncilFields from '../../organisation-council-fields'
import { useParamsOr404 } from '../../../../../hooks/use-params-or-404'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  ButtonsContainer,
  Divider,
  FormField,
  Heading,
  ReadOnlyField,
  RecordContainer,
  RecordContent,
  RecordFooter,
  RepeatableSection,
  useTitleChange,
  WorkflowNav,
} from '@msaf/core-react'

export default function Organisation() {
  useTitleChange('Administration | View organisation')
  const navigate = useNavigate()
  const { id: organisationId } = useParamsOr404('id')
  const url = `administration/organisation/${organisationId}/view`
  const [fields, setFields] = useState<Partial<OrganisationFieldsView>>({})

  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <RecordContainer
      workflowNav={
        <WorkflowNav
          sections={[{ links: [{ path: `/admin/organisations/${organisationId}/view`, label: 'Details' }] }]}
        />
      }
    >
      <RecordContent>
        <ButtonsContainer containerStyle='left'>
          <Button
            onClick={() => navigate(`/admin/organisations`, { state: { activeTab: 2 } })}
            label='Back'
            iconAlignment='left'
            icon='arrow-left'
            buttonStyle='text-action'
          />
        </ButtonsContainer>
        <Heading level={2}>Organisation details</Heading>
        <FormField isSkeleton={isLoading} labelId='organisation' label='Organisation'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='organisation' value={`${fields.company ?? ''}`} />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='companyType' label='Company type'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='companyType' value={`${fields.companyType ?? ''}`} />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='address' label='Address'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='address' value={`${fields.addressConsolidated ?? ''}`} />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='companyNumber' label='Contact number'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='address' value={`${fields.companyNumber ?? ''}`} />
        </FormField>
        <Divider />
        <Heading level={2}>Organisation permissions</Heading>
        <FormField isSkeleton={isLoading} labelId='companyStatus' label='Status'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='companyStatus' value={`${fields.companyStatus ?? ''}`} />
        </FormField>
        <RepeatableSection disableNumberedSections heading='' sectionName='' isSkeleton={isLoading}>
          {fields.councils?.map((council: OrganisationCouncilFieldsEdit) => (
            <OrganisationCouncilFields
              key={council.id}
              fields={council}
              isLoading={isLoading}
              setValue={() => {
                /** Do nothing in view mode */
              }}
              validationErrors={{}}
              company={fields.company ?? ''}
              isDisabledSection
            />
          ))}
        </RepeatableSection>
      </RecordContent>
      <RecordFooter areActionsFixed={true}>
        <Button label='Edit record' path={`/admin/organisations/${organisationId}/edit`} />
      </RecordFooter>
    </RecordContainer>
  )
}
